<template>
	<div class="incenters">
		<div style="">
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="新增" fontSize="14px" @btnclick="adduser"
				:src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.update" title="修改" fontSize="14px" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.del" title="删除" fontSize="14px" @btnclick="del"
				:src="require('@/assets/icon/icon-del.png')">
			</Commonbtn>
			<CommonbtnUpLoad backgroundColor="#FFF" v-if="qx.add" title="导入" fontSize="14px" @getFile="InvoiceImport"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<Commonbtn backgroundColor="#FFF" v-if="qx.daoc" title="导出" fontSize="14px" @btnclick="CRExport"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<a class="Dowload" style="" @click="busDowload">下载经销商医院业务员关系导入模板</a>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable @handleSelectionChange="handleSelectionChange" @onRowClick="onRowClick" colnum=522
				:tableData="tableData" :headerData="headerData" height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<DialogFrom width="640px" title="新增业务员医院关系" :dialogVisible="dialogVisibles" @cancel="cancel"
			@dialogOK="dialogOK">
			<div class="from">
				<template v-for="(item , index) of fromdataadd">
					<Commondropdownlist :key="index" ref="addbusiness" :loading="loading" :disabledHB="item.disabled"
						@remoteMethodtows="remoteMethodtows" @remoteMethodtowPer="remoteMethodtowPer"
						@remoteMethodtowHB="remoteMethodtowHB" :options="item.options" :btx="item.btx"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :min="item.min" :max="item.max" :checkboxdata="item.checkboxdata"
						:disabled="item.disabled" @change="(val) => onAddFieldChange(index, val)">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>
		<DialogFrom width="640px" title="编辑业务员医院关系" :loading="loading" :dialogVisible="dialogVisiblesedit"
			@cancel="canceledit" @dialogOK="dialogOKedit">
			<div class="from">
				<template v-for="(item , index) of fromdataedit">
					<Commondropdownlist ref="editbusiness" :key="index" :options="item.options"
						:disabledHB="item.disabled" @remoteMethodtows="remoteMethodtows"
						@remoteMethodtowPer="remoteMethodtowPer" @remoteMethodtowHB="remoteMethodtowHB"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" :min="item.min" :max="item.max" @change="(val) => onEditFieldChange(index, val)">
					</Commondropdownlist>
				</template>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该业务员医院关系吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledeactivate" @cancel="canceldeactivate"
			@dialogOK="dialogOKdeactivate" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停用这条档案吗？</span>
		</Dialog>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from" style="">
				<Commontable width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../../components/common-dropdownlist.vue'
	import Commontable from '../../../../components/common-table.vue'
	import Commonbtn from '../../../../components/common-btn.vue'
	import Pagination from '../../../../components/pagination.vue'
	import DialogFrom from '../../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import Dialog from '../../../../components/dialog.vue'
	import Commondown from '../../../../components/common-down.vue'
	import CommonbtnUpLoad from '../../../../components/common-upload.vue'
	import arrAll from '../../../../common/area'
	import {
		InventoryClassList,
		CustomerList,
		HospitalList,
		CusRelationUserInfoList,
		CusRelationHospitalInfo,
		CusRelationHospitalEdit,
		CusRelationHospitalAdd,
		CusRelationHospitalDelete,
		CusRelationHospitalImport,
		CusRelationDownloadTemplet,
		TechnicalOfficesList,

	} from '@/api/home'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			Commondown,
			CommonbtnUpLoad
		},
		props: {
			tableData: {
				type: Array,
				default: []
			},
			total: {
				type: Number,
				default: 0
			}
		},
		data: function() {
			return {
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				dialogVisibledeactivate: false,
				dialogVisiblesU8: false,
				dialogVisiblesU8d: false,
				dialogVisiblesdrjg: false,
				rowboo: false,
				arrCityAll: arrAll, //全部城市
				cityArr: [], //市
				rightboo: false,
				dwonleft: false,
				loading: false,
				title: '',
				ID: '',
				ptype: '',
				CusCodeName: '',
				HPIDName: '',
				HPID: null,
				TechnicalOfficesName: '',
				TechnicalOfficesID: null,
				fromdataadd: [],
				fromdataedit: [],
				rowTableData: [],
				tableDatadrjg: [],
				IDs: [],
				fromdataU8: [{
					inputdata: '',
					title: 'U8账套',
					fontSize: '14px',
					color: '#333333',
					placeholder: '请输入',
					types: 'text',
					inputtype: 'input',
					width: '210px',
					lablewith: '55px'
				}, {
					inputdata: '',
					title: 'U8编号',
					fontSize: '14px',
					color: '#333333',
					placeholder: '请输入',
					types: 'text',
					inputtype: 'input',
					width: '210px',
				}, ],
				headerData: [{
						prop: 'id',
						label: '序号',
						columnwidth: 50,
					},
					{

						prop: 'HPName',
						label: '医院名称',
						columnwidth: 200
					},
					{
						prop: 'TechnicalOffices',
						label: '科室',
						columnwidth: 160
					},
					{
						prop: 'InvClassName',
						label: '产品线',
						columnwidth: 100
					},
					{
						prop: 'CusName',
						label: '经销商',
						columnwidth: 260
					},
					{
						prop: 'TrueName',
						label: '销售员',
						columnwidth: 160
					},
					{
						prop: "ProvinceMan",
						label: "省级经理",
						columnwidth: 200
					},
					{
						prop: 'AreaMan',
						label: '小区经理',
						columnwidth: 160
					},
					{
						prop: 'RegionMan',
						label: '大区经理',
						columnwidth: 160
					},
					{
						prop: 'CountryMan',
						label: '全国总监',
						columnwidth: 160
					},
					{
						prop: 'HPProvinceName',
						label: '医院省份',
						columnwidth: 160
					},
					{
						prop: 'CreatorName',
						label: '创建人',
						columnwidth: 130
					},
					{
						prop: 'UpdaterName',
						label: '修改人',
						columnwidth: 130
					},
					{
						prop: 'CreateTime',
						label: '创建日期',
						columnwidth: 162
					}
				],
				tableData1: [{
						kong: '',
						U8id: '1',
						U8number: '102100024',
					},
					{
						kong: '',
						U8id: '2',
						U8number: '102100024',
					},
					{
						kong: '',
						U8id: '3',
						U8number: '102100024',
					},
				],
				headerData1: [{
						prop: 'kong',
						columnwidth: 39,
						types: 'selection'

					},
					{
						prop: 'U8id',
						label: 'U8账套',
						columnwidth: 400,

					},
					{

						prop: 'U8number',
						label: 'U8编号',
						columnwidth: 522
					},
				],
				downlist: [{
						title: 'U8配置'
					},
					{
						title: '导入U8配置'
					},
				],
				qus: [],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					setting: false
				},
			}
		},
		created() {

		},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			let data = JSON.parse(localStorage.getItem("MenusData"))
			data.Menus[0].Nodes.map((item, index) => {
				if (item.NodeID == 35) {
					item.Nodes.map((items, indexs) => {
						if (items.NodeID == 52) {
							this.qus = items.Nodes
						}
					})
				}
				// console.log(this.qus, 'this.qus');
			})
			if (this.qus) {
				this.qus.map((item, index) => {
					if (item.NodeName == 'add') {
						this.qx.add = true
					} else if (item.NodeName == 'edit') {
						this.qx.update = true
					} else if (item.NodeName == 'delete') {
						this.qx.del = true
					} else if (item.NodeName == 'stopif') {
						this.qx.del = true
					} else if (item.NodeName == 'assignment') {
						this.qx.assignment = true
					} else if (item.NodeName == 'enabled') {
						this.qx.enabled = true
					} else if (item.NodeName == 'skip') {
						this.qx.skip = true
					} else if (item.NodeName == 'reset') {
						this.qx.reset = true
					} else if (item.NodeName == 'setting') {
						this.qx.setting = true
					}
				})
			}
			this.inventoryClassList()
		},
		methods: {
			async loadTechnicalOfficesOptions(hospitalId, target) {
				if (hospitalId === undefined || hospitalId === null || hospitalId === '') return
				const hospitalIdStr = String(hospitalId)
				if (!/^\d+$/.test(hospitalIdStr)) return

				let {
					code,
					data
				} = await TechnicalOfficesList({
					Hospital: hospitalId
				})
				if (code == 0) {
					const list = Array.isArray(data) ? data : (data && data.data ? data.data : [])
					const options = list.map((item) => ({
						key: item.TOID ?? item.TechnicalOfficesID ?? item.ID,
						value: item.TOName ?? item.TechnicalOffices ?? item.Name
					})).filter(it => it.key !== undefined && it.key !== null && it.value !== undefined && it.value !== null)

					if (target === 'edit') {
						if (this.fromdataedit[1]) this.fromdataedit[1].options = options
					} else {
						if (this.fromdataadd[1]) this.fromdataadd[1].options = options
					}
				}
			},
			onAddFieldChange(index, val) {
				if (index !== 0) return
				if (this.fromdataadd[1]) this.fromdataadd[1].options = []
				if (this.$refs.addbusiness && this.$refs.addbusiness[1]) this.$refs.addbusiness[1].modelvalue = ''
				if (!/^\d+$/.test(String(val || ''))) return
				this.loadTechnicalOfficesOptions(val, 'add')
			},
			onEditFieldChange(index, val) {
				if (index !== 0) return
				if (this.fromdataedit[1]) this.fromdataedit[1].options = []
				if (this.$refs.editbusiness && this.$refs.editbusiness[1]) this.$refs.editbusiness[1].modelvalue = ''
				if (!/^\d+$/.test(String(val || ''))) return
				this.loadTechnicalOfficesOptions(val, 'edit')
			},
			// 详情
			async CusRelationHospitalInfo() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载详情中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message,
					data
				} = await CusRelationHospitalInfo({
					ID: this.ID
				})
				if (code == 0) {
					this.fromdataedit[0].inputdata = data.HPName
					this.fromdataedit[1].inputdata = data.TechnicalOffices || data.TechnicalOfficesName || data.TOName || ''
					this.fromdataedit[2].inputdata = data.InvClass
					this.fromdataedit[3].inputdata = data.CusName
					this.fromdataedit[4].inputdata = data.UserName
					this.CusCodeName = data.CusCode
					this.HPIDName = data.HPName
					this.HPID = data.HPID
					this.TechnicalOfficesName = this.fromdataedit[1].inputdata
					this.TechnicalOfficesID = data.TechnicalOfficesID || data.TOID || data.TechnicalOfficesId || null
					await this.loadTechnicalOfficesOptions(this.HPID, 'edit')
					loading.close();
					this.dialogVisiblesedit = true
				}
				loading.close();
			},
			// 修改
			async CusRelationHospitalEdit() {
				// if(this.HPIDName == this.$refs.editbusiness[0].modelvalue){
				//    this.$message({
				//     type: 'warning',
				//     message: '您修改数据与修改前数据一致'
				//   })
				//   return
				// }
				const loading = this.$loading({
					lock: true,
					text: '修改中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				let {
					code,
					message
				} = await CusRelationHospitalEdit({
					ID: this.ID,
					HPID: this.$refs.editbusiness[0].modelvalue == this.HPIDName ? this.HPID : this.$refs
						.editbusiness[0].modelvalue,
					TechnicalOfficesID: this.$refs.editbusiness[1].modelvalue == this.TechnicalOfficesName ? this.TechnicalOfficesID : this.$refs.editbusiness[1].modelvalue,
					InvClass: this.$refs.editbusiness[2].modelvalue,
					CusCode: this.CusCodeName,
					UserName: this.$refs.editbusiness[4].modelvalue,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '修改成功'
					});

					this.rowboo == false
					loading.close();
					this.dialogVisiblesedit = false
					this.$parent.CusRelationHospitalList()
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}

				loading.close();
			},
			// 新增
			async CusRelationHospitalAdd() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message
				} = await CusRelationHospitalAdd({
					// ID: Number(this.rowTableData[0].ID),
					HPID: this.$refs.addbusiness[0].modelvalue,
					TechnicalOfficesID: this.$refs.addbusiness[1].modelvalue,
					InvClass: this.$refs.addbusiness[2].modelvalue,
					CusCode: this.$refs.addbusiness[3].modelvalue,
					UserName: this.$refs.addbusiness[4].modelvalue,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '新增成功'
					});
					this.$refs.addbusiness.map((item, index) => {
						item.modelvalue = ""
					})
					this.rowboo == false
					loading.close();
					this.$parent.CusRelationHospitalList()
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
				loading.close();
			},
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.fromdataadd[2].options = []
					this.fromdataedit[2].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.fromdataedit[2].options.push(obj)
						this.fromdataadd[2].options.push(obj)
					})
				}
			},
			// 导入
			async cusRelationHospitalImport(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await CusRelationHospitalImport(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})

						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: 'warning',
							message: res.message
						})
						loading.close();
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = "导入结果"
						this.$message({
							type: 'error',
							message: res.message
						})
						loading.close();
					}
					this.$parent.CusRelationHospitalList()
					loading.close();
				}
			},
			InvoiceImport(file) {
				this.cusRelationHospitalImport(file)
			},
			// 模板下载
			async cusRelationDownloadTemplet() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
				let {
					data,
					code,
					message
				} = await CusRelationDownloadTemplet({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			busDowload() {
				this.cusRelationDownloadTemplet()
			},
			async remoteMethodtows(query) {
				this.loading = true
				let {
					code,
					data
				} = await CustomerList({
					cusName: query
				})
				if (code == 0) {
					this.fromdataedit[3].options = []
					this.fromdataadd[3].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.CusCode,
							value: item.CusName
						}
						this.fromdataedit[3].options.push(obj)
						this.fromdataadd[3].options.push(obj)

					})
					this.loading = false
				}
			},
			async remoteMethodtowHB(query) {
				this.loading = true
				let {
					code,
					data
				} = await HospitalList({
					hpName: query,
					HosType: "医院",
					// pageSize: 100,
					// pageIndex: 1
				})
				if (code == 0) {
					this.fromdataedit[0].options = []
					this.fromdataadd[0].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.HPID,
							value: item.HPName
						}
						this.fromdataedit[0].options.push(obj)
						this.fromdataadd[0].options.push(obj)

					})
					this.loading = false
				}
			},
			async remoteMethodtowPer(query) {
				this.loading = true
				let {
					code,
					data
				} = await CusRelationUserInfoList({
					TrueName: query,
					UserOrg: "00"
				})
				if (code == 0) {
					this.fromdataedit[4].options = []
					this.fromdataadd[4].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.UserName,
							value: item.TrueName + "(" + item.UserName + ")"
						}
						this.fromdataedit[4].options.push(obj)
						this.fromdataadd[4].options.push(obj)
					})
					this.loading = false
				}
			},
			// 删除
			async cusRelationHospitalDelete() {
				let IDs = []
				this.rowTableData.map((item, index) => {
					IDs.push(item.ID)
				})
				let {
					code,
					message
				} = await CusRelationHospitalDelete({
					iDs: IDs
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: "删除成功"
					})
					this.dialogVisibledel = false
					this.$parent.CusRelationHospitalList()

				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
			},
			CRExport() {
				this.$emit('CRExport')
			},
			onRowClick(val) {
				this.ID = val.ID
				this.rowboo = true
				//console.log('val', val)
			},
			adduser() {
				this.dialogVisibles = true
				// //console.log(this.fromdataadd, '//console.log(this.fromdataadd)')
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				this.CusRelationHospitalAdd()
				this.dialogVisibles = false
			},
			update() {
				if (this.rowboo == true) {
					this.CusRelationHospitalInfo()
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要修改的数据！'
				});

			},
			canceledit() {
				this.dialogVisiblesedit = false
			},
			dialogOKedit() {
				this.CusRelationHospitalEdit()

			},
			del() {
				if (this.rowTableData.length > 0) {
					this.dialogVisibledel = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要删除的数据！'
				});

			},
			canceldel() {
				this.dialogVisibledel = false
			},
			dialogOKdel() {
				this.cusRelationHospitalDelete()
				this.dialogVisibledel = false
			},
			deactivate() {
				this.dialogVisibledeactivate = true
			},
			canceldeactivate() {
				this.dialogVisibledeactivate = false
			},
			dialogOKdeactivate() {
				this.dialogVisibledeactivate = false
			},
			downs(index) {
				// //console.log("index", index)
				if (index == 0) {
					this.dialogVisiblesU8 = true
				}
				if (index == 1) {
					this.dialogVisiblesU8d = true
				}
			},
			cancelU8() {
				this.dialogVisiblesU8 = false
			},
			dialogOKeditU8() {
				this.dialogVisiblesU8 = false
			},
			cancelU8d() {
				this.dialogVisiblesU8d = false
			},
			dialogOKeditU8d() {
				this.dialogVisiblesU8d = false
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			handleSelectionChange(val) {
				this.rowTableData = val
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			}
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 16px;
			padding-bottom: 16px;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
		}

		.signingroles {
			height: 500px;
			width: 100%;
			// display: flex;
			// justify-content: space-between;
			// align-items: center;
			// border: 1px solid red;

			.left {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
			}

			.right {
				height: 240px;
				width: 470px;
				border: 1px solid #e6e6e6;
				// pointer-events: none;
			}
		}
	}

	.right-s {
		position: absolute;
		z-index: 99;
		opacity: 0.5;
		right: 21px;
		width: 470px;
		height: 240px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		right: 350px;
		top: 322px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}
</style>
